import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white rounded-2xl border border-gray-200 p-5" }
const _hoisted_2 = { class: "flex items-center justify-between gap-4" }
const _hoisted_3 = {
  "data-ring": "",
  class: "h-10 w-10 rounded-full bg-white grid place-items-center text-xs font-extrabold"
}
const _hoisted_4 = { class: "mt-3 text-sm divide-y divide-gray-100" }
const _hoisted_5 = { class: "text-gray-600" }
const _hoisted_6 = { class: "font-bold text-gray-900" }
const _hoisted_7 = { class: "h-16 mt-3" }
const _hoisted_8 = {
  key: 1,
  class: "text-xs text-gray-500 mt-3"
}

import { computed } from 'vue'

import BarChart from '@/components/BarChart.vue'

import MarketingMilestones from './MarketingMilestones.vue'
import { ordersByDayChart, pct } from './marketingSeries'

const RING_DARK = '#111827'
const RING_TRACK = '#e5e7eb'


export default {
  __name: 'MarketingScoreboard',
  props: {
  summary: { type: Object, default: () => ({}) },
  ordersByDay: { type: Object, default: null },
  milestones: { type: Array, default: null }
},
  setup(__props) {

const props = __props
const decided = computed(() => props.summary.decided_count || 0)
const total = computed(() => props.summary.total_count || 0)
const share = computed(() => (total.value ? Math.round((decided.value / total.value) * 100) : 0))
const ringStyle = computed(() => ({
  background: `conic-gradient(${RING_DARK} 0 ${share.value}%, ${RING_TRACK} ${share.value}% 100%)`
}))
const showChart = computed(() => (props.summary.orders || 0) > 0 && Boolean(props.ordersByDay))
const rows = computed(() => {
  const s = props.summary
  const delivered = s.reached || 0
  return [
    { label: 'Approved', value: `${s.approved_count || 0} of ${total.value}` },
    { label: 'Texts delivered', value: delivered },
    { label: 'Replied', value: delivered ? pct((s.replies || 0) / delivered) : 'n/a' },
    { label: 'Orders with a play code', value: s.orders || 0 }
  ]
})
const chart = computed(() => ordersByDayChart(props.ordersByDay))
const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: { legend: { display: false }, title: { display: false } },
  scales: { x: { display: false }, y: { display: false } }
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", null, [
        _createElementVNode("p", { class: "text-xs text-gray-500" }, "This month"),
        _createElementVNode("h3", { class: "text-sm font-bold text-gray-900" }, "Plan progress")
      ], -1)),
      _createElementVNode("div", {
        class: "h-14 w-14 rounded-full grid place-items-center",
        style: _normalizeStyle(ringStyle.value)
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(decided.value) + "/" + _toDisplayString(total.value), 1)
      ], 4)
    ]),
    _createElementVNode("dl", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row) => {
        return (_openBlock(), _createElementBlock("div", {
          key: row.label,
          class: "flex justify-between py-1.5"
        }, [
          _createElementVNode("dt", _hoisted_5, _toDisplayString(row.label), 1),
          _createElementVNode("dd", _hoisted_6, _toDisplayString(row.value), 1)
        ]))
      }), 128))
    ]),
    (showChart.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(BarChart, {
              "chart-data": chart.value,
              "chart-options": options
            }, null, 8, ["chart-data"])
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-xs text-gray-500 mt-1" }, "Orders per day · send days dark", -1))
        ], 64))
      : (_openBlock(), _createElementBlock("p", _hoisted_8, "Numbers start the night after your first send.")),
    _createVNode(MarketingMilestones, {
      class: "mt-4",
      milestones: __props.milestones || [],
      compact: ""
    }, null, 8, ["milestones"])
  ]))
}
}

}